(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function init(el) {
      if (el.__gwInit) return;
      el.__gwInit = true;

      var size = parseInt(el.dataset.size, 10) || 4;
      var maxSize = Math.max(size, parseInt(el.dataset.maxSize, 10) || size);
      var percent = parseFloat(el.dataset.percent) || 0;
      var pairDisc = parseInt(el.dataset.pairDiscount, 10) || 0;
      var fmt;
      try {
        fmt = new Intl.NumberFormat(el.dataset.locale || 'de', { style: 'currency', currency: el.dataset.currency || 'EUR' });
      } catch (e) {
        fmt = { format: function (n) { return n.toFixed(2) + ' €'; } };
      }
      var money = function (cents) { return fmt.format(cents / 100); };

      var picked = [];
      var items = Array.prototype.slice.call(el.querySelectorAll('[data-gw-item]'));
      var slots = Array.prototype.slice.call(el.querySelectorAll('[data-gw-slot]'));

      var activeSize = el.dataset.sizeActive || '36-40';

      function variantsOf(li) {
        if (!li.__variants) {
          try { li.__variants = JSON.parse(li.dataset.variants || '{}'); } catch (e) { li.__variants = {}; }
        }
        return li.__variants;
      }

      function itemData(li, size) {
        var sz = size || activeSize;
        var v = variantsOf(li)[sz];
        if (!v || !v.available) return null;
        return {
          variantId: String(v.id),
          productId: li.dataset.productId,
          price: v.price,
          regular: v.regular || v.price,
          size: sz,
          title: li.dataset.title + ' · ' + sz,
          img: v.img,
          propName: v.pre ? el.dataset.propName : '',
          propValue: v.pre ? el.dataset.propValue : ''
        };
      }

      function render() {
        var count = picked.length;
        slots.forEach(function (slot, i) {
          var p = picked[i];
          slot.innerHTML = '';
          slot.classList.toggle('is-filled', !!p);
          slot.classList.toggle('is-next', !p && i === count);
          if (p) {
            var img = document.createElement('img');
            img.src = p.img;
            img.alt = p.title;
            slot.appendChild(img);
            var sz = document.createElement('span');
            sz.className = 'gw-bundle__slot-size';
            sz.textContent = p.size.replace('-', '–');
            slot.appendChild(sz);
            var rm = document.createElement('button');
            rm.type = 'button';
            rm.className = 'gw-bundle__slot-remove';
            rm.textContent = '×';
            rm.setAttribute('aria-label', (el.dataset.txtRemove || 'Remove') + ': ' + p.title);
            rm.addEventListener('click', function () { picked.splice(i, 1); render(); });
            slot.appendChild(rm);
          } else {
            var n = document.createElement('span');
            n.className = 'gw-bundle__slot-num';
            n.textContent = i < size ? i + 1 : '+';
            slot.appendChild(n);
          }
        });

        items.forEach(function (li) {
          var c = picked.filter(function (p) { return p.productId === li.dataset.productId; }).length;
          var badge = li.querySelector('[data-gw-count]');
          if (badge) { badge.hidden = c === 0; badge.textContent = '×' + c; }
          var minus = li.querySelector('[data-gw-minus]');
          if (minus) minus.hidden = c === 0;
          li.classList.toggle('is-picked', c > 0);
          var add = li.querySelector('[data-gw-add]');
          if (add) add.disabled = count >= maxSize || !itemData(li);
        });

        // Neues Set-Modell: [size] Paare = fester Set-Preis (data-set-price). Kein Vorbestellungsrabatt mehr.
        var current = picked.reduce(function (s, p) { return s + p.price; }, 0);
        var complete = count >= size;
        var setPrice = parseInt(el.dataset.setPrice, 10) || 0;
        var setPct = 0;
        var regular = current;
        var total = complete && setPrice ? setPrice : current;
        var setDisc = complete ? Math.max(0, current - total) : 0;
        var preDisc = 0;
        el.querySelector('[data-gw-subtotal]').textContent = count ? money(regular) : '–';
        el.querySelector('[data-gw-setprice]').textContent = complete && setDisc > 0 ? '−' + money(setDisc) : '–';
        var pctEl = el.querySelector('[data-gw-setpct]');
        if (pctEl) pctEl.textContent = !pairDisc && complete && setPct > 0 ? '(−' + (Math.floor(setPct * 100)).toLocaleString(el.dataset.locale || 'de') + ' %)' : '';
        var extraRow = el.querySelector('[data-gw-extra-row]');
        if (extraRow) extraRow.hidden = true;
        var discEl = el.querySelector('[data-gw-discount]');
        if (discEl) discEl.textContent = count && preDisc > 0 ? '−' + money(preDisc) : '–';
        el.querySelector('[data-gw-total]').textContent = count ? money(total) : '–';

        var status;
        if (count < size) status = el.dataset.txtPick.replace(/\[count\]/g, size - count);
        else if (count < maxSize) status = el.dataset.txtReadyMore.replace(/\[count\]/g, maxSize - count);
        else status = el.dataset.txtReadyMax;
        el.querySelector('[data-gw-status]').textContent = status;
        el.querySelector('[data-gw-progress]').style.width = Math.min(100, count / size * 100) + '%';
        el.querySelector('[data-gw-cta]').disabled = !complete;
      }

      el.addEventListener('click', function (event) {
        var minus = event.target.closest('[data-gw-minus]');
        if (minus) {
          var pid = minus.closest('[data-gw-item]').dataset.productId;
          for (var k = picked.length - 1; k >= 0; k--) {
            if (picked[k].productId === pid) { picked.splice(k, 1); break; }
          }
          render();
          return;
        }
        var add = event.target.closest('[data-gw-add]');
        if (add) {
          if (picked.length >= maxSize) return;
          var data = itemData(add.closest('[data-gw-item]'));
          if (!data) return;
          picked.push(data);
          render();
          return;
        }
        var f = event.target.closest('[data-gw-size]');
        if (f) {
          activeSize = f.dataset.gwSize;
          el.querySelectorAll('[data-gw-size]').forEach(function (b) {
            b.classList.toggle('is-active', b === f);
            b.setAttribute('aria-pressed', b === f ? 'true' : 'false');
          });
          render();
          return;
        }
        var cta = event.target.closest('[data-gw-cta]');
        if (cta && !cta.disabled) addToCart(cta);
      });

      async function addToCart(btn) {
        var label = btn.querySelector('[data-gw-cta-label]');
        var original = label.textContent;
        btn.disabled = true;
        label.textContent = el.dataset.txtAdding;

        // Neues Set-Modell: genau [size] Paare -> 1x Produkt "Dein Set" (Festpreis), Paare als Eigenschaften.
        // _gw_variants (versteckt) nutzt der Flow, um den Bestand der Einzelpaare abzuziehen.
        var setVariant = Number(el.dataset.setVariant || 0);
        var lineItems;
        if (setVariant && picked.length === size) {
          var props = {};
          var pairLabel = el.dataset.txtPair || 'Paar';
          picked.forEach(function (p, i) { props[pairLabel + ' ' + (i + 1)] = p.title.replace(/-/g, '\u2013'); });
          var withPre = picked.some(function (p) { return p.propName; });
          if (withPre && el.dataset.propName) props[el.dataset.propName] = el.dataset.propValue;
          props._gw_variants = picked.map(function (p) { return p.variantId; }).join(',');
          lineItems = [{ id: setVariant, quantity: 1, properties: props }];
        } else {
          var grouped = {};
          picked.forEach(function (p) {
            if (!grouped[p.variantId]) {
              grouped[p.variantId] = { id: Number(p.variantId), quantity: 0 };
              if (p.propName) { grouped[p.variantId].properties = {}; grouped[p.variantId].properties[p.propName] = p.propValue; }
            }
            grouped[p.variantId].quantity += 1;
          });
          lineItems = Object.keys(grouped).map(function (k) { return grouped[k]; });
        }

        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) {
          if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
        });

        var events = null;
        try { events = await import('@shopify/events'); } catch (e) { events = null; }
        var deferred = null;
        if (events && events.CartLinesUpdateEvent) {
          deferred = events.CartLinesUpdateEvent.createPromise();
          btn.dispatchEvent(new events.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: lineItems.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }),
            promise: deferred.promise
          }));
        }

        try {
          var res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lineItems, sections: sectionIds.join(',') })
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'error');
          var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

          if (deferred) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'gw-bundle-builder',
                sourceId: 'gw-bundle-builder',
                itemCount: size,
                productId: picked[0] && picked[0].productId,
                sections: data.sections,
                didError: false
              }
            });
          } else {
            window.location.href = root + 'cart';
            return;
          }

          label.textContent = el.dataset.txtAdded;
          setTimeout(function () {
            picked = [];
            label.textContent = original;
            render();
          }, 1800);
        } catch (err) {
          console.error(err);
          if (deferred) deferred.reject(err);
          label.textContent = el.dataset.txtError;
          setTimeout(function () { label.textContent = original; render(); }, 2500);
        }
      }

      // aktuelles Produkt vorauswählen
      if (el.dataset.current) {
        items.some(function (li) {
          var map = variantsOf(li);
          return Object.keys(map).some(function (k) {
            if (String(map[k].id) === el.dataset.current) {
              var d0 = itemData(li, k);
              if (d0) picked.push(d0);
              return true;
            }
            return false;
          });
        });
      }
      render();
    }

    function boot() { document.querySelectorAll('[data-gw-bundle]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
